import { render, staticRenderFns } from "./ProductStockSection.vue?vue&type=template&id=7e0d0c3e&scoped=true&"
import script from "./ProductStockSection.vue?vue&type=script&lang=js&"
export * from "./ProductStockSection.vue?vue&type=script&lang=js&"
import style0 from "./ProductStockSection.vue?vue&type=style&index=0&id=7e0d0c3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e0d0c3e",
  null
  
)

export default component.exports